<template>
     <header class="header">
        <div class="bg-primary text-white py-2" style="background: linear-gradient(120deg,#020101, #020101);">
            <div class="container-fluid">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 d-none d-sm-block">
                <ul class="list-inline mb-0">
                        <li class="list-inline-item mr-3">
                            <a class="reset-anchor" href="#">
                            <img src="@/assets/svg/marker.svg" width="15px" height="15px">
                                <span class="font-weight-normal text-small">
                                1 Club Road, Golden Gate, Regimanuel Gray Estate, East Airport, Accra
                                </span>
                            </a>
                        </li>
                
                    </ul>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                        <img src="@/assets/svg/phone.svg" width="15px" height="15px">
                        <a class="text-small reset-anchor" href="tel:+2330302811740">+233 050 145 3030 </a>
                    </li>
                </ul>
                </div>
               <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                    <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                            <a target="_blank" class="font-weight-bold text-small reset-anchor" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=info@rgeahosa.org">
                            <img src="@/assets/svg/mail.svg" width="15px" height="15px">
                            </a>
                            <a target="_blank" class="text-small reset-anchor"  href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=info@rgeahosa.org">
                            info@rgeahosa.org 
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            </div>
        </div>
        <nav class="navbar navbar-expand-lg navbar-light bg-white">
            <div class="container-fluid">

            <router-link class="navbar-brand" to="/">
                <img src="@/assets/logo.png" alt="" width="150">
            </router-link>

            <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
               <span class="navbar-toggler-icon"></span>
            </button>
            
            <div class="collapse navbar-collapse" id="navbarSupportedContent">

             <ul class="navbar-nav ml-auto">
                
                <li class="nav-item mx-2" :class="[selected.includes('main_page') ? 'active' : '']">
                   <!-- <router-link class="nav-link" to="/" @click="go()">Home</router-link> -->
                   <a class="nav-link" href="" @click.prevent="goHome()">Home</a>
                </li>

                <li class="nav-item ml-2 dropdown" v-if="!isAuthorized" >
                    <a class="nav-link dropdown-toggle pr-0" id="navbarDropdownMenuLink" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Member Access
                    </a>
                    <div class="dropdown-menu dropdown-menu-right mt-lg-4" aria-labelledby="navbarDropdownMenuLink">
                         <router-link class="dropdown-item text-small" to="/login">Login</router-link>
                         <router-link class="dropdown-item text-small" to="/register">Registration</router-link>
                    </div>
                </li>

                <li v-if="isAuthorized"  class="nav-item mx-2" :class="[selected.includes('documents_library') ? 'active' : '']">
                     <router-link class="nav-link" to="/library">Documents</router-link>
                </li>

                 <li v-if="isAuthorized"  class="nav-item mx-2" :class="[selected.includes('events') ? 'active' : '']">
                     <router-link class="nav-link" to="/events">Events / Notices</router-link>
                </li>

                <li v-if="isAuthorized" class="nav-item mx-2" :class="[selected.includes('council_members') ? 'active' : '']">
                     <router-link class="nav-link" to="/council">Council Members</router-link>
                </li>

                 <li v-if="isAuthorized" class="nav-item mx-2" :class="[selected.includes('gallery') ? 'active' : '']">
                     <router-link class="nav-link" to="/gallery">Gallery</router-link>
                </li>

                <li class="nav-item mx-2" :class="[selected.includes('Contacts') ? 'active' : '']">
                     <router-link class="nav-link" to="/contacts">Contact Us</router-link>
                </li>

                <li class="nav-item ml-2 dropdown" v-if="isAuthorized">
                    <a class="nav-link dropdown-toggle pr-0" id="navbarDropdownMenuLink" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <img :src="profile" class="img img-profile" width="20px" height="20px"> 
                    </a>
                    <div class="dropdown-menu dropdown-menu-right mt-lg-4" aria-labelledby="navbarDropdownMenuLink">
                        <a href="" class="dropdown-item text-small">
                            <img :src="profile" class="img img-profile" width="15px" height="15px"> 
                            <span>  {{ firstname }} </span><hr>
                        </a>
                        <router-link class="dropdown-item text-small" to="/account">Account</router-link>
                        <a class="dropdown-item text-small" href="#" @click.prevent="logout()">Logout</a>
                    </div>
                </li>


                </ul>
            </div>
            </div>
        </nav>
     </header>
</template>
<script>
import UserServices from "../../services/UserServices";
import avatar from '../../assets/png/avatar-png-1.png';
export default {
   data() {
       return {
            isAuthorized: false,
            firstname: '',
            profile:'',
            activeAccess: false,
            user:{
                name:'',
                lastname:'',
                email:'',
            }
       }
   }, 

   methods: {
        async logoutUser(){
            try {
                const resp = await UserServices.logout();
                return resp;
            } catch (e) {
                return e;
            }
        },

        logout() {
            this.logoutUser().then((resp)=>{ 
                console.log(resp)
                localStorage.removeItem('token');
                localStorage.removeItem('firstname');
                location.reload(true)                   
            })
        },

        goHome(){
           window.location.href = '/';
        }
   },

   created() {
       this.firstname = localStorage.getItem('firstname');
       if(localStorage.getItem('profile') === "") {
         this.profile = avatar;
       } else {
         this.profile = localStorage.getItem('profile');
       }
   },

   computed:{
        selected(){
           return this.$route.name;
        },
   },

    mounted(){
        if(localStorage.getItem('token') != null){
            this.isAuthorized = true;
        }
    },
}
</script>
<style>
  @import '../../assets/css/bootstrap.css';
  @import '../../assets/css/custom.css';
  @import '../../assets/css/owl.carousel.css';
  @import '../../assets/css/owl.theme.default.css';
  @import '../../assets/css/style.default.css';
  @import 'https://fonts.googleapis.com/css?family=Work+Sans:300,400,800&amp;display=swap';


  .img-profile{
      border-radius: 50%;
  }
</style>